<!-- FAQs Section -->
<section id="faqs" class="py-16 lg:py-24 bg-[#f5f6f8] text-slate-800 relative border-t border-[#0e3b2e]/10">
  <div class="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
    <div class="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">

      <!-- LEFT: intro + support card -->
      <div class="lg:col-span-4 lg:sticky lg:top-24 space-y-8">
        <div class="space-y-4">
          <span class="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.2em] text-[#e6b012]">
            <span class="h-4 w-1 rounded-full bg-[#e6b012]"></span> FAQs
          </span>
          <h2 class="text-3xl lg:text-4xl font-black tracking-tight text-[#0e3b2e] leading-[1.1]">
            Frequently Asked
            <span class="block text-[#bcb365]">Questions</span>
          </h2>
          <p class="text-sm leading-relaxed text-slate-500">
            Find answers to common questions about the Government MEL System and how it supports Tanzania's national
            development agenda.
          </p>
        </div>

        <!-- Still have questions card -->
        <div class="rounded-2xl bg-[#0e3b2e] p-7 shadow-lg">
          <h3 class="text-lg font-extrabold text-white">Still have questions?</h3>
          <p class="mt-2 text-sm leading-relaxed text-white/70">
            Our MEL support team is available to assist government institutions and registered users.
          </p>
          <a
            href="mailto:support@mel.go.tz"
            class="mt-5 inline-flex items-center gap-1.5 rounded-full bg-[#e6b012] px-5 py-2.5 text-xs font-extrabold tracking-wide text-white shadow-md transition-all hover:bg-[#d4a00e] active:scale-95"
          >
            <span>Contact Support</span>
            <span class="text-sm leading-none">›</span>
          </a>
        </div>
      </div>

      <!-- RIGHT: accordion -->
      <div class="lg:col-span-8 space-y-4">
        @for (faq of faqs; track $index) {
          <div
            class="rounded-2xl border bg-white transition-all duration-300"
            [class]="faq.isOpen ? 'border-[#e6b012] shadow-md' : 'border-slate-200/70 shadow-xs hover:border-slate-300'"
          >
            <!-- Question row -->
            <button
              (click)="toggleFaq($index)"
              class="flex w-full items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
            >
              <span
                class="text-base font-bold leading-snug transition-colors"
                [class]="faq.isOpen ? 'text-[#e6b012]' : 'text-[#0e3b2e]'"
              >
                {{ faq.question }}
              </span>
              <span
                class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-white transition-colors"
                [class]="faq.isOpen ? 'bg-[#e6b012]' : 'bg-[#0e3b2e]'"
              >
                <mat-icon class="!text-[20px] !w-5 !h-5 !leading-5">{{ faq.isOpen ? 'remove' : 'add' }}</mat-icon>
              </span>
            </button>

            <!-- Answer -->
            @if (faq.isOpen) {
              <div class="border-t border-slate-100 px-6 pb-6 pt-4 text-sm leading-relaxed text-slate-600">
                {{ faq.answer }}
              </div>
            }
          </div>
        }
      </div>

    </div>
  </div>
</section>
